@if (cardListConfig(); as cardListConfig) {
  @if (data(); as data) {
    <div class="row {{ andClass() }} card-list">
      <div class="col-12">
        <div class="ps-3 pe-3 pb-2 d-sm-block d-none">
          <div class="row card-list-heading-row">
            @for (item of cardListConfig.items; track item) {
              <div class="col-12 {{ item.andClass }} {{ item.headerClass }}">
                <div
                  class="d-flex align-items-center justify-content-between"
                  [class.clickable]="item.sortable"
                  (click)="setSort(item)">
                  <div class="card-list-heading">
                    <span [tooltip]="item.label | translate" placement="top">
                      {{ item.label | translate }}
                    </span>
                    @if (item.headerTooltipMessage) {
                      <nk-help-popover placement="top" [popoverTemplate]="item.headerTooltipMessage"></nk-help-popover>
                    }
                  </div>
                  @if (item.sortable && data.sorts; as sortDict) {
                    <div>
                      <i
                        class="fa sort-icon"
                        [ngClass]="{
                          'fa-sort': !sortDict[item.prop],
                          'fa-sort-up': sortDict[item.prop] === 'asc',
                          'fa-sort-down': sortDict[item.prop] === 'desc',
                        }"></i>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div [class.faded-3]="isLoading()">
          @for (entity of data.entities; track trackByUuid($index, entity)) {
            <nk-card-list-item
              [noBorder]="noBorder()"
              [entity]="entity"
              [items]="cardListConfig.items"
              [collapsibleDetails]="collapsibleDetails()"
              [detailsComponent]="cardListConfig.detailsComponent"></nk-card-list-item>
          }
        </div>

        @if (cardListConfig.noDataMessage && !data.entities.length) {
          <nk-card-list-item [noBorder]="noBorder()" [items]="cardListConfig.items">
            <nk-card [andClass]="noBorder() ? 'mb-2 border-0' : 'mb-2'">
              <nk-card-content andClass="p-3">
                <div class="text-muted">
                  <em>
                    {{ cardListConfig.noDataMessage | translate }}
                  </em>
                </div>
              </nk-card-content>
            </nk-card>
          </nk-card-list-item>
        }

        @if (data.entities.length < data.pagination.totalCount && data.entities.length > 0) {
          <div class="row card-list-pagination">
            <div class="col-4 d-flex align-items-center">
              <span class="text-muted">
                {{ 'common.pagination.total_count' | translate: { totalCount: data.pagination.totalCount } }}
              </span>
            </div>
            <div class="col-8 d-flex justify-content-end">
              <nk-pagination
                [currentPage]="data.pagination.page"
                [totalItems]="data.pagination.totalCount"
                [itemsPerPage]="data.pagination.limit"
                [maxSize]="3"
                (changePage)="onChangePage($event)"></nk-pagination>
            </div>
          </div>
        }
      </div>
    </div>
  }
}
